import axios from 'axios';
import moment from 'moment';

const SERVER_ADDRESS = "boat_reservation.php";

export default class ServerApi {
    static createBooking(boat, date, slot, code, callback) {
        let params = {
            b: boat,
            d: date.format("YYYY-MM-DD"),
            s: slot,
            c: code,
            t: 'a'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            let data = response.data || {};
            if(data.success) {
                callback(true);
            } else {
                callback(false, data.error);
            }
        }).catch(e => {
            console.log(e);
            callback(false, "Errore di comunicazione");
        });
    }
    static deleteBooking(boat, date, slot, code, callback) {
        let params = {
            b: boat,
            d: date.format("YYYY-MM-DD"),
            s: slot,
            c: code,
            t: 'd'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            let data = response.data || {};
            if(data.success) {
                callback(true);
            } else {
                callback(false, data.error);
            }
        }).catch(e => {
            console.log(e);
            callback(false, "Errore di comunicazione");
        });
    }
    static editComment(boat, date, slot, comment, code, callback) {
        let params = {
            b: boat,
            d: date.format("YYYY-MM-DD"),
            s: slot,
            c: code,
            t: 'c'
        };
        axios.post(SERVER_ADDRESS, {comment: comment}, {params}).then(response => {
            let data = response.data || {};
            if(data.success) {
                callback(true);
            } else {
                callback(false, data.error);
            }
        }).catch(e => {
            console.log(e);
            callback(false, "Errore di comunicazione");
        });
    }
    static queryContact(swsnr, code, callback) {
        let params = {
            n: swsnr,
            c: code,
            t: 'i'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            let data = response.data || {};
            if(data.success) {
                callback(true, data);
            } else {
                callback(false, data.error);
            }
        }).catch(e => {
            console.log(e);
            callback(false, "Errore di comunicazione");
        });
    }
    static getBookings(boat, start, end, callback) {
        let params = {
            b: boat,
            s: start.format("YYYY-MM-DD"),
            e: end.format("YYYY-MM-DD"),
            t: 'b'
        };
        axios.get(SERVER_ADDRESS, {params}).then(response => {
            callback(response.data);
        }).catch(e => {
            console.log(e);
            callback({});
        });
    }
};
